export default {
    unit: {
        type: {
            // units without technical data, e.g. doors and gates (HCIT-943)
            label           : "Anlagenart",
            noSpecification : "Keine technischen Daten verfügbar",
            change: {
                sameGroup: "<p>Die Anlagenart wird von <b>{0}</b> nach <b>{1}</b> geändert und sofort gespeichert.</p><p>Noch nicht gespeicherte Änderungen der technischen Daten gehen dabei verloren. Mit <b>JA</b> wird die Änderung übernommen.</p>",
                query: "Anlagenart ändern?",
                text : "<p>Die Anlagenart wurde von <b>{0}</b> nach <b>{1}</b> geändert.</p><p><b>Spezifikation</b>, <b>TZB</b> und ggf. <b>GBU</b> müssen daher neu initialisiert werden.</p><p>Dadurch gehen ggf. Daten verloren. Soll die Änderung wirklich durchgeführt werden? Mit <b>JA</b> wird die Änderung übernommen.</p>"
            }
        },

        common: {
            hcId: "HC-ID",
            no  : "Fabriknummer"
        },

        audit: {
            gbu: {
                history: "GBU Historie",
            }
        },

        escalator: {
            general   : "Allgemeine Daten",
            technical : "Technische Daten",
            mounting  : "Einbausituation",
            features  : "Besonderheiten",
            additional: "Weitere Angaben (Bestand)",
            siteType  : "Anlagentyp",
            kind      : "Anlagenart",
            manufacturer: "Hersteller",
            yearOfConstruction: "Baujahr",
            rebuilder : "Umbaufirma",
            yearOfRebuild: "Umbaujahr",
            model     : "Modell",
            type      : "Typ",
            auditBook : "Prüfbuch",
            sprinkler : "Sprinkleranlage",
            liftingHeight: "Förderhöhe (m)",
            gradient  : "Neigung (Grad)",
            stepWidthMm: "Stufen-/Palettenbreite (mm)",
            horizontalStepsTop: "Horizontale Stufen oben",
            horizontalStepsBottom: "Horizontale Stufen unten",
            speed     : "Geschwindigkeit",
            floorRange: "Ebene/Geschoss",
            drivingDirection: "Fahrtrichtung",
            mountingPosition: "Einbaulage",
            otherFeatures: "Sonstige Merkmale",
            legacy: {
                stepType      : "Stufenart",
                stepWidth     : "Stufenbreite (alt)",
                stepsRunout   : "Auslaufstufen",
                stepsAccessible: "Gleichzeitige Stufen",
                layerDistance : "Auflageabstand (m)",
                balustradeType: "Balustradenart",
                locationDrive : "Lage Antrieb",
                lighting      : "Beleuchtungsart",
                socleSurface  : "Sockeloberfläche",
                socleBrush    : "Sockelbürsten",
                switchPeriod  : "Austausch Zeitpunkt",
                switchCosts   : "Austausch Kosten",
                mountingPosition: "Einbaulage (Text)",
                auditBook     : "Prüfbuch (Text)",
            },
            lighting: {
                title      : "Beleuchtung",
                stepBand   : "Stufenbandbeleuchtung",
                balustrade : "Balustradenbeleuchtung",
                combCarrier: "Kammträgerbeleuchtung",
                stepGap    : "Stufenspaltbeleuchtung",
                other      : "Sonstige Beleuchtung",
                otherText  : "Welche?",
            },
            tzb: {
                title      : "Fahrtreppen-TZB",
                drive      : "Antrieb",
                automatic  : "Steuerung",
                control    : "Regelung",
                driveType  : "Antriebsart",
                automaticType: "Steuerungsart",
                controlType: "Regelungsart",
                handrails  : "Handläufe",
                balustrade : "Balustrade",
                socle      : "Sockel",
                socleBrushes: "Sockelbürsten",
                steps      : "Stufen",
                combs      : "Kämme",
                maintenance: "Wartungsqualität",
                company    : "Wartungsfirma",
                note       : "Notiz (nur LM4)",
                saved      : "Notizen des TZB gespeichert.",
                readonly   : "Nur der aktuelle TZB kann bearbeitet werden.",
            },
        },

        tzb: {
            title       : "Allgemeiner Anlagenzustand",
            manufacturer: "Hersteller",
            assessor    : "Gutachter",
            history     : "TZB Historie",
            reports     : "TZB Reports",
            inspection  : "Datum",
            model       : "Typ",
            condition   : "Zustand",
            engine: {
                title   : "Antrieb (Motor und Getriebe)",
                label   : "Antriebsart"
            },
            automatic: {
                title   : "Steuerung",
                subtitle: "Sammelsteuerung",
                label   : "Steuerungsart"
            },
            control: {
                title   : "Regelung",
                label   : "Regelungsart"
            },
            manholeDoor: {
                title   : "Schachttüren",
                label   : "Art"
            },
            emcSystem: {
                title   : "Notrufsystem",
                label   : "Art"
            },
            saftyCatch: {
                title   : "Fangvorrichtung",
                label   : "Art"
            },
            doorDrive: {
                title   : "Türantrieb",
                label   : "FK-Türart",
                sublabel: "FK-Tür-Antriebsart"
            },
            speedLimiter: {
                title   : "Geschwindigkeitsbegrenzer",
                label   : "GB-Art",
                sublabel: "Kopierungsart"
            },
            car: {
                title    : "Fahrkorb",
                wall     : "Wände",
                floor    : "Boden",
                ceiling  : "Decke",
                lightning: "Beleuchtung",
                mirror   : "Spielgel",
                vandalism: "Vandalismus"
            },
            maintenance: {
                title     : "Wartungsqualität",
                engineRoom: "Maschinenraum",
                manwhole  : "Schacht und Grube",
                carRoof   : "Fahrkorbdach"
            },
            modernization: {
                measure: "Maßnahme Sanierung",
                note   : "Maßnahme",
                costs  : "Kosten"
            },
            budget: {
                title: "Empfohlene Maßnamen",

                unit: {
                    measure: "Maßnahme",
                    comment: "Bemerkungen",
                    budget  : "Budget"
                },
            },

        },

        customer: {
            dispo: {
                title  : "Wechsel des Kunden nicht möglich",
                message: "Die Anlage ist aktuell im Auftrag <b>{0}</b> zur Begehung eingeplant. Daher kann der Wechsel zu einem anderen Kunden aktuell nicht durchgeführt werden."
            },
            change: {
                query: "Soll der Kunde geändert werden?",
                text : "Durch den Wechsel des Kunden werden alle bestehenden Zuordnungen zu Verträgen, Kontakten und Adressen aufgelöst. Mit <b>JA</b> wird der Wechsel zum neuen Kunden durchgeführt."
            }
        },

        message: {
            assigned       : "Die Zuordnung zu der Anlage {0} wurde verarbeitet. Bitte ggf. noch die Ansprechpartner anpassen",
            alreadyAssigned: "Die Zuordnung zur Anlage {2} existiert bereits" ,
            dissolved      : "Die Zuordnung zu der Anlage {0} wurde aufgelöst. Bitte ggf. noch die Ansprechpartner anpassen",
        },
        query: {
            dissolve: {
                query: "Soll die Anlage aus dem {0} entfernt werden?",
                text : "Die Anlage wird nicht gelöscht. Es wird lediglich die Zuordnung zu der, gewählten {0} aufgelöst. Soll die Zuordnung nun aufgelöst werden?"
            }
        },
        error: {

        },

        core: {
            warranty   : "Gewährleistung"
        },

        menu: {
            incidents  : "Ereignisse zur Anlage",
            create     : "Ein neues Ereignis anlegen",
            images     : "Bilder zur Anlage",
            sitedetails: "Details",
            siteedit   : "Bearbeiten",
            warranty   : "Gewährleistung",
        },
        edit: {
            menu: {
                edit    : "Anlage bearbeiten",
                readonly: "Anlage nur anzeigen",
                save    : "Änderungen speichern",
                refresh : "Anlage erneut laden",
                close   : "Anzeige schliessen",
                history : "Historie",
                reports : "Reports",
                measures: "Maßnahmen bearbeiten"
            }
        },

        bulkupdate: {
            command: "Änderungen ausführen",
            units: {
                title: "Anlagen",
            },
            customer: {
                select: "Neuer Kunde",
                confirm: {
                    query: "Kunde ändern?",
                    text : "<p>Sollen der Kunden <b>{0}</b> den <b>{1}</b> Anlagen aus der Anzeige zugeordnet werden?</p><p></p>Mit <b>JA</b> wird die Änderung unwiderruflich übernommen.</p>"
                }
            },
            edit: {
                title: "Änderung",
                type1: "Kunde ändern"
            },
        }
    },
}